// @flow
import React from "react"
import classnames from "classnames"
import type { Element } from "react"

export type ButtonSize = "small" | "large" | "medium" | "xlarge"
export type ButtonKind =
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "inverted"
  | "danger"
  | "facebook"
  | "google"

// exported to stories knobs
export const kind = {
  primary: "primary",
  secondary: "secondary",
  success: "success",
  warning: "warning",
  danger: "danger",
  inverted: "inverted",
  facebook: "facebook",
  google: "google",
}

type Props = {
  kind: ButtonKind,
  children?: Element<any>,
  className: string,
  size?: ButtonSize,
  fullwidth?: ?boolean,
  disabled?: ?boolean,
  loading?: ?boolean,
}

const ButtonWrapper = (props: Props) => {
  const { size = "" } = props

  return React.cloneElement(props.children || <span />, {
    // Overrides the first child's className
    className: classnames(props.className, "ButtonWrapper", {
      [`_${size}`]: props.size,
      [`_${props.kind}`]: props.kind,
      _fullwidth: props.fullwidth,
      _disabled: props.disabled,
      _loading: props.loading,
    }),
  })
}

ButtonWrapper.defaultProps = {
  className: "",
}

export default ButtonWrapper
